import { FabricObject, Textbox } from 'fabric';
import { Fill } from '../../shared/utils/fill';
import type { TextAlign } from '../../shared/types/text-align';

export interface SobreimpresoMeta {
  fill: Fill;
  stroke: string;
  strokeWidth: number;
  borderRadius: number;
  paddingX: number;
  paddingY: number;
  /** Floor on the banner height; text stays vertically centered in the extra space. */
  minHeight: number;
}

/** @deprecated Use TextAlign — kept as an alias for the public API. */
export type SobreimpresoTextAlign = TextAlign;

export interface SobreimpresoCreateConfig {
  left: number;
  top: number;
  width: number;
  text: string;
  fill: Fill;
  textFill: string;
  fontFamily: string;
  fontSize: number;
  fontWeight?: number | string;
  fontStyle?: 'normal' | 'italic';
  textAlign?: SobreimpresoTextAlign;
  borderRadius?: number;
  paddingX?: number;
  paddingY?: number;
  height?: number;
  stroke?: string;
  strokeWidth?: number;
}

export type SobreimpresoTextbox = Textbox & { sobreimpreso: SobreimpresoMeta };

export function isSobreimpresoTextbox(obj: FabricObject | null | undefined): obj is SobreimpresoTextbox {
  return !!obj && obj instanceof Textbox && !!(obj as SobreimpresoTextbox).sobreimpreso;
}
